export default __webpack_public_path__ + "static/media/instagram.64446823.png";